var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fe415ed89127f8d47f361210e868db4b20578b6f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kfh-gatsby@fresh-egg-limited"]={id:"fe415ed89127f8d47f361210e868db4b20578b6f"};
      